module.exports = __webpack_public_path__ + "img/IT0000102484824.860af4ad.png";